module.exports = __webpack_public_path__ + "static/media/bbms-logo.05e3b5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bbms-logo.png
// module id = 106
// module chunks = 0